
import BackArrowSvg from "@Assets/svg/Dashboard-svgs/BackArrow.svg";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getExamDetails, getFeedback, getLeaderBoardTestSeries, getTestResult, getTestSeriesResult, getUserTestReview, getUserTestSeriesReview } from "../Service/Dashboard.service";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { useEffect, useState } from "react";
import { getLeaderBoard } from "../Service/Dashboard.service";
import "./TestResult.scss";
import { AppRouteURL } from "@Constants/app-route-url.constant";
import { MathJax } from "better-react-mathjax";
import { LeaderboardResult } from "./components/LeaderboardResult/LeaderboardResult";
import ReviewResult from "./components/ReviewResult/ReviewResult";
import { ReviewResultType } from "@Constants/app.constant";
import { Skeleton } from "primereact/skeleton";
import { FeedbackForm } from "./components/FeedbackForm/FeedbackForm";
import { useAnalyticsAccess } from "@Src/hooks/useAnalyticsAccess";
import { NoSubscriptionDialog } from "@Components/NoSubscriptionDialog/NoSubscriptionDialog";
import { useAppSelector } from "@App/hooks";
import { isInstituteStudent } from "@Src/utils/studentTypeUtils";
import toast from "react-hot-toast";
import { Trans, useTranslation } from "react-i18next";


export const TestResultIndex = () => {
    const navigation = useNavigate()
    const [resultdata, setresultdata] = useState<any>([])
    const [Reviewdata, setReviewdata] = useState<any>([])
    const [allAnswersData, setAllAnswersData] = useState([])
    const [correctAnswersData, setCorrectAnswersData] = useState([])
    const [incorrectAnswersData, setIncorrectAnswersData] = useState([])
    const [TimeValue, setTimeValue] = useState('')
    const [LeaderDetails, setLeaderDetails] = useState([]);
    const [showDataReviewType, setShowDataReviewType] = useState(ReviewResultType.ALL_ANSWERS);

    const [subjectList, setSubjectList] = useState<string[]>([]);
    const [classList, setClassList] = useState<string[]>([]);
    const [boardName, setBoardName] = useState<string>('');
    const [duration, setDuration] = useState<any>();
    const [testseriesId, setTestSeriesId] = useState<any>();
    const [chapterTopics, setChapterTopics] = useState<any>();
    const [testName,setTestName]=useState<any>();


    const params = useParams()
    const userValueId = Number(params.TestResultsId)
    // const [searchParams] = useSearchParams();
    const location = useLocation();

    const id = location.state?.userTestId;
    const testType = location.state?.testType;
    const testId = location.state?.testId;
    const examId = location.state?.examId;;
    const examType = Number(location.state?.examType || 0);



    // const id = Number(searchParams.get('userTestId'));
    // const testType = Number(searchParams.get('testType'));
    // const testId = Number(searchParams.get('testId'));
    // const examId = Number(searchParams.get('examId'));
    // const examType = Number(searchParams.get('examType') || 0);
    const [activetab, setActivetab] = useState<any>(ReviewResultType.ALL_ANSWERS)
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [leaderboardResultLoading, setLeaderboardResultLoading] = useState<boolean>(true);
    // Analytics access check
    const { isCheckingAccess, hasAnalyticsAccess } = useAnalyticsAccess();
    const userState = useAppSelector((state: any) => state.login);
    const isInstitute: boolean = isInstituteStudent(userState);
    const { t } = useTranslation("common");


    useEffect(() => {
        window.scrollTo(0, 0);
        const dashboardContent = document.querySelector('.dashboard-content-page');
        if (dashboardContent) {
            dashboardContent.scrollTo(0, 0);
        }

        if (examId) {
            getTestSeriesResultDetails()
            // getleaderTestSeriesdata()
            getTestSeriesReview();
        } else {
            getResultDetails()
            // getleaderdata()
            gettestreview()
        }
    }, [testType])

    // Scroll to top when data loading completes
    useEffect(() => {
        if (!isLoading && !leaderboardResultLoading) {
            setTimeout(() => {
                window.scrollTo(0, 0);
                document.querySelector('.dashboard-content-page')?.scrollTo(0, 0);
            }, 50);
        }
    }, [isLoading, leaderboardResultLoading]);

    // useEffect(() => {
    //     if (examId) {
    //         getTestSeriesReview();
    //     } else {
    //         gettestreview()
    //     }
    // }, [id])

    /*--------------------------------result-data-from-api-------------------*/
    const getResultDetails = () => {
        if (testId) {
            setLeaderboardResultLoading(true)
            let params = {
                'testId': testId,
                'testType': testType,
                'id': id,
            }
            getTestResult(params).then((response: APIResponse) => {
                if (response.ResponseType === APIStatus.SUCCESS) {
                    setresultdata(response?.data)
                    let time = getDuration(response?.data[0]?.['UsedDuration']);
                    setTimeValue(time)
                }
            }).catch((error: any) => {
                console.log(error)
            }).finally(() => {
                setLeaderboardResultLoading(false);
            })
        }
    }

    const getTestSeriesResultDetails = () => {
        if (examId) {
            setLeaderboardResultLoading(true)
            let params = {
                'examId': examId,
                'testType': testType,
                'id': id
            }
            getTestSeriesResult(params).then((response: APIResponse) => {
                if (response.ResponseType === APIStatus.SUCCESS) {
                    setresultdata(response?.data)
                    let time = getDuration(response?.data[0]?.['UsedDuration']);
                    setTimeValue(time)
                }
            }).catch((error: any) => {
                console.log(error)
            }).finally(() => {
                setLeaderboardResultLoading(false);
            })
        }
    }

    /*----------------------review-data-from-api----------------------*/
    const gettestreview = () => {
        if (id) {
            let params = {
                'userTestId': id
            }
            setIsLoading(true);
            getUserTestReview(params).then((response: APIResponse) => {
                setIsLoading(false);
                if (response.ResponseType === APIStatus.SUCCESS) {
                    setModifiedReviewData(response.data)
                }
            }).catch((error: any) => {
                setIsLoading(false);
                console.log(error)
            })
        }

    }

    const getTestSeriesReview = () => {
        if (id) {
            let params = {
                'userTestId': id
            }
            setIsLoading(true);
            getUserTestSeriesReview(params).then((response: APIResponse) => {
                setIsLoading(false);
                if (response.ResponseType === APIStatus.SUCCESS) {
                    setReviewdata(response.data);
                    setAllAnswersData(response.data)
                    setModifiedReviewData(response.data)
                }
            }).catch((error: any) => {
                setIsLoading(false);
                console.log(error)
            })
        }

    }

    const setModifiedReviewData = (reviews: any) => {
        let modifiedReviews: any = [];
        if (reviews && reviews.length) {
            reviews.forEach((review: any) => {
                let ansType = review.AnsType;


                if (review.QuestionTypeId == 2) {
                    const selected = review.SelectedOption ? review.SelectedOption.trim().split(',').map((s: string) => s.trim().toLowerCase()).filter((s: string) => s !== 'null' && s !== '') : [];
                    const actualAns = review.Ans ? review.Ans.trim().split(',').map((s: string) => s.trim().toLowerCase()).filter((s: string) => s !== 'null' && s !== '') : [];

                    if (selected.length > 0) {
                        const hasIncorrect = selected.some((opt: string) => !actualAns.includes(opt));
                        if (!hasIncorrect) {
                            ansType = 1;
                        } else {
                            ansType = 0;
                        }
                    } else {
                        ansType = 2;
                    }
                }

                let modifiedReview = {
                    ...review,
                    'selected': false,
                    'AnsType': ansType,
                    TimeToShow: getDuration(review.Time)
                }
                modifiedReviews.push(modifiedReview);
            });
        }
        setReviewdata(modifiedReviews);
        setAllAnswersData(modifiedReviews)
        divideReviewData(modifiedReviews);
    }

    const divideReviewData = (reviews: any) => {
        let correctAnswers: any = [];
        let inCorrectAnswers: any = [];
        reviews.forEach((review: any) => {
            if (review.AnsType == 0) {
                inCorrectAnswers.push(review);
            } else if (review.AnsType == 1) {
                correctAnswers.push(review);
            }
        });
        setCorrectAnswersData(correctAnswers);
        setIncorrectAnswersData(inCorrectAnswers);
    }
    /*------------------------------Leader-board-data-------------------*/

    // const getleaderdata = () => {
    //     let params = {
    //         'testId': testId,
    //         'testType': testType,
    //         'id': id,
    //     }
    //     if (testId) {
    //         getLeaderBoard(params).then((response: APIResponse) => {
    //             if (response.ResponseType === APIStatus.SUCCESS) {
    //                 setLeaderDetails(response.data)
    //             }
    //         }).catch((error: any) => {
    //             console.log(error)
    //         })
    //     }

    // }

    // const getleaderTestSeriesdata = () => {
    //     let params = {
    //         'examId': examId,
    //         'testType': testType,
    //         'id': id,
    //     }
    //     if (examId) {
    //         getLeaderBoardTestSeries(params).then((response: APIResponse) => {
    //             if (response.ResponseType === APIStatus.SUCCESS) {
    //                 setLeaderDetails(response.data)
    //             }
    //         }).catch((error: any) => {
    //             console.log(error)
    //         })
    //     }

    // }

    const getDuration = (durationdata: any) => {
        let hours: any = Math.floor(durationdata / 3600);
        let minutes: any = Math.floor((durationdata - (hours * 3600)) / 60);
        let seconds: any = durationdata - (hours * 3600) - (minutes * 60);

        if (hours > 0) {
            hours = (hours < 10) ? "0" + hours : hours;
        } else {
            hours = '';
        }
        minutes = (minutes < 10) ? "0" + minutes : minutes;
        seconds = (seconds < 10) ? "0" + seconds : seconds;
        let time = hours + (hours ? ":" : '') + minutes + ":" + seconds
        return time;
    }

    const onClickShowExplanation = (index: number, selected: boolean) => {
        // const previousReviews: any = [...Reviewdata];
        // let previousReview = previousReviews[index];
        // previousReview['selected'] = !selected;
        // 2. Mark the todo as complete
        const updatedReviewExplanationStatus = { ...Reviewdata[index], selected: !selected };
        // 3. Update the todo list with the updated todo
        const updatedReviews = [...Reviewdata];
        updatedReviews[index] = updatedReviewExplanationStatus;
        setReviewdata(updatedReviews);
        // setReviewdata(previousReviews);

    }

    const onClickReviewDataType = (type: string) => {
        setActivetab(type)
        switch (type) {
            case ReviewResultType.ALL_ANSWERS:
                //   setReviewdata(allAnswersData);
                setShowDataReviewType(type);
                break;
            case ReviewResultType.CORRECT_ANSWERS:
                //  setReviewdata(correctAnswersData);
                setShowDataReviewType(type);
                break;
            case ReviewResultType.INCORRECT_ANSWERS:
                //   setReviewdata(incorrectAnswersData);
                setShowDataReviewType(type);
                break;
        }
    }
    const fetchExamDetails = () => {
        getExamDetails({ examId: examId.toString() }).then((response: any) => {
            if (response.ResponseType === APIStatus.SUCCESS && response.data) {
                // const sortedSubjects = (response.data.SubjectList || []).slice().sort((a: string, b: string) => a.toLowerCase().localeCompare(b.toLowerCase()));
                const sortedClasses = (response.data.ClassList || []).slice().sort((a: string, b: string) => a.toLowerCase().localeCompare(b.toLowerCase()));
                setSubjectList(response.data.SubjectList || []);
                setClassList(sortedClasses);
                setDuration(response.data.Duration)
                setTestSeriesId(response.data.Id)
                setChapterTopics(response.data.ChapterList)
                setBoardName(response.data.BoardName)
                setTestName(response.data.Name)
            }
        }).catch((error: any) => {
            console.log(error)
        })
    }
    useEffect(() => {
        fetchExamDetails()
    }, [examId])


    return (
        <>
            {isCheckingAccess ? (
                <div className="leader-board-container">
                    <div className="leader-header">
                        <span className="back-btn-span" onClick={() => navigation(AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY)}>
                            <img src={BackArrowSvg} alt="back-svg" />
                        </span>
                        {t("your_performance_&_improvement_plan")}
                    </div>
                    <SkeletonCardResultIndex />
                </div>
            ) : hasAnalyticsAccess ? (
                <>
                    {
                        !location.state ? <div className="leader-board-container">
                            <div className="leader-header">
                                <span className="back-btn-span" onClick={() => navigation(AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY)}>
                                    <img src={BackArrowSvg} alt="back-svg" />
                                </span>
                                {t("your_performance_&_improvement_plan")}
                            </div>
                            <div className="tw-p-10 tw-text-center tw-text-lg tw-font-medium tw-text-gray-600">
                                <Trans
                                    i18nKey="no_performance_report_found"
                                    values={{ performanceReport: t("performance_report") }}
                                    components={{
                                        highlight: (
                                            <b className="tw-text-purple-700" />
                                        ),
                                    }}
                                />
                            </div>

                        </div>
                            :
                            <div className="leader-board-container ">
                                <div className="leader-header" >
                                    <span className="back-btn-span" onClick={() => navigation(AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY)}>
                                        <img src={BackArrowSvg} alt="back-svg" />
                                    </span>
                                    {t("your_performance_&_improvement_plan")}
                                </div>
                                {
                                    leaderboardResultLoading ? <SkeletonCardResultIndex /> : <LeaderboardResult testType={testType} resultdata={resultdata} LeaderDetails={LeaderDetails} userValueId={userValueId} examId={examId} testId={testId} TimeValue={TimeValue} examType={examType} userTestId={id} subjectList={subjectList} classList={classList} duration={resultdata[0]?.['Duration']} testseriesId={testseriesId} chapterTopics={chapterTopics} Reviewdata={Reviewdata} boardName={boardName} testName={testName} />

                                }
                                {/* <LeaderboardResult testType={testType} resultdata={resultdata} LeaderDetails={LeaderDetails} userValueId={userValueId} examId={examId} testId={testId} TimeValue={TimeValue} examType={examType} /> */}
                                <div className="review-mock-test-container">
                                    <div className="review-mock-test-tabs">
                                        {
                                            Reviewdata?.length > 0 && <div className={`r-m-t-heading  ${(activetab === ReviewResultType.ALL_ANSWERS) ? 'active-tab' : ''}`} onClick={() => onClickReviewDataType(ReviewResultType.ALL_ANSWERS)} >{t("review_mock_test")}</div>
                                        }
                                        {correctAnswersData && correctAnswersData.length ?
                                            <div className={`r-m-t-heading  ${(activetab === ReviewResultType.CORRECT_ANSWERS) ? 'active-tab' : ''}`} onClick={() => onClickReviewDataType(ReviewResultType.CORRECT_ANSWERS)} >{t("correct")} {t("answers")}</div>
                                            : ''}
                                        {incorrectAnswersData && incorrectAnswersData.length ?
                                            <div className={`r-m-t-heading  ${(activetab === ReviewResultType.INCORRECT_ANSWERS) ? 'active-tab' : ''}`} onClick={() => onClickReviewDataType(ReviewResultType.INCORRECT_ANSWERS)} >{t("incorrect")} {t("answers")}</div>
                                            : ''}
                                    </div>

                                    {isLoading ?
                                        <SkeletonCardResultIndex />
                                        :
                                        // winding up whole part inside mathjax component instead of small separate components to process mathjax formulas fast
                                        <MathJax>
                                            <ReviewResult Reviewdata={Reviewdata} showDataReviewType={showDataReviewType} duration={resultdata[0]?.['Duration']} questions={resultdata[0]?.['NoOfQuestion']} testType={testType} userTestId={id} getTestSeriesReview={getTestSeriesReview}/>
                                        </MathJax>
                                    }
                                </div>
                                <FeedbackForm UserTestId={`${id}`} />
                            </div>
                    }

                </>

            ) : (
                <div className="leader-board-container">
                    <div className="leader-header">
                        <span className="back-btn-span" onClick={() => navigation(AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY)}>
                            <img src={BackArrowSvg} alt="back-svg" />
                        </span>
                        {t("your_performance_&_improvement_plan")}
                    </div>
                    <div className="tw-p-10 tw-text-center tw-text-lg tw-font-medium tw-text-gray-600">
                        {isInstitute ? (

                            <Trans
                                i18nKey="no_permission_review_institute"
                                values={{ "analysisName": t("your_performance_&_improvement_plan") }}
                                components={{
                                    highlight: (
                                        <b className="tw-text-purple-700" />
                                    ),
                                }}
                            />
                        ) : (
                            <Trans
                                i18nKey="no_permission_review_student"
                                values={{ "analysisName": t("your_performance_&_improvement_plan") }}
                                components={{
                                    highlight: (
                                        <b className="tw-text-purple-700" />
                                    ),
                                }}
                            />

                        )}
                    </div>
                    <FeedbackForm UserTestId={`${id}`} />
                </div>
            )}


        </>
    )
}

export const SkeletonCardResultIndex = () => {
    return (
        <div>
            {[...Array(10)].map((e, i) => (
                <div className="dashboard-card" key={i}>
                    <div className="tw-flex tw-flex-wrap tw-mt-3">
                        <span className="tw-flex tw-items-center">
                            <Skeleton width="1.5rem" height="1.5rem"></Skeleton>
                            <Skeleton width="10rem" className="tw-ml-3"></Skeleton>
                        </span>
                    </div>
                    <div className="tw-flex tw-flex-wrap tw-mt-3">
                        <Skeleton width="60rem" height="5rem" className="mr-2"></Skeleton>
                    </div>
                    <div className="tw-flex tw-mt-3 tw-flex-wrap">
                        <span className="tw-flex tw-items-center">
                            <Skeleton width="1.5rem" height="1.5rem"></Skeleton>
                            <Skeleton width="50rem" className="tw-ml-3"></Skeleton>
                        </span>
                    </div>
                    <div className="tw-flex tw-mt-3 tw-flex-wrap">
                        <span className="tw-flex tw-items-center">
                            <Skeleton width="1.5rem" height="1.5rem"></Skeleton>
                            <Skeleton width="50rem" className="tw-ml-3"></Skeleton>
                        </span>
                    </div>
                    <div className="tw-flex tw-mt-3 tw-flex-wrap">
                        <span className="tw-flex tw-items-center">
                            <Skeleton width="1.5rem" height="1.5rem"></Skeleton>
                            <Skeleton width="50rem" className="tw-ml-3"></Skeleton>
                        </span>
                    </div>
                    <div className="tw-flex tw-mt-3 tw-flex-wrap">
                        <span className="tw-flex tw-items-center">
                            <Skeleton width="1.5rem" height="1.5rem"></Skeleton>
                            <Skeleton width="50rem" className="tw-ml-3"></Skeleton>
                        </span>
                    </div>
                </div>
            ))}
        </div>
    )
}